export default __webpack_public_path__ + "static/media/logo-dark-svg.6840c4d3.svg";